module Enums {
    export enum eRole {
        Administrator = 1,
        Client = 2,
        Supervisor = 3,
        Hotel = 4,
        Police = 5,
        SuperAdministrator = 6,
        EveHandler = 10
    }

    export enum eParkingLotStat {
        Free = 1,
        Occupied = 2,
        Booked = 3,
    }

    export enum eSchedulerType {
        Standard = 1,
        Daily = 2,
        Special = 3,
    }
    export enum eParkingType {
        Public = 1,
        Private = 2,
    }
    export enum eTariffType {
        Standard = 1,
        PerDay = 2,
    }
    export enum eDayOfWeek {
        Monday = 1,
        Tuesday = 2,
        Wednesday = 3,
        Thursday = 4,
        Friday = 5,
        Saturday = 6,
        Sunday = 7,
    }
    export enum eCurrencyType {
        RON = 1,
        EUR = 2,
        USD = 3,
    }
    export enum eParkingLevel {
        Underground = 1,
        Surface = 2,
        Multilevel = 3,
    }
    export enum eSensorEditState {
        Unedited = 1,
        New = 2,
        Edited = 3,
        Removed = 4,
    }

    export enum ePaymentMethodType {
        Cash = 1,
        Card = 2,
        SMS = 3,
    }

    export enum ePaymentType {
        Park = 1,
        Fine = 2,
    }

    export enum eCardType {
        Unrecognized = 1,
        Ambiguous = 2,
        Amex = 3,
        JCB = 4,
        Visa = 5,
        Mastercard = 6,
        Discover = 7
    }

    export enum eInstitutionType {
        Company = 1,
        TownHallOrPolice = 2,
    }

    export enum eIncomingsType {
        Today = 1,
        Last7Days = 2,
        Last30Days = 3,
        CurrentMonth = 4,
        LastMonth = 5
    }

    export enum eLanguage {
        Romanian = 1,
        English = 2
    }

    export enum eStatisticsType {
        Hourly = 1,
        Daily = 2,
        Monthly = 3
    }

    export enum eFineStat {
        Issued = 1,
        Processed = 2,
        Cancelled = 3,
        Fined = 4
    }

    export enum eVehicleCheckStat {
        Valid = 1,
        Invalid = 2,
        ToBeFined = 3,
        PreviouslyFined = 4,
        ElectricException = 5,
        Subscription = 6
    }
}
export default Enums;
